export default {
  VOCUST_APP_BASE_ID: {
    key: "VOCUST_APP_BASE_ID"
  },
  VOCUST_APP_LANGUAGE: {
    key: "VOC-LANGUAGE"
  }
}
